export default "__VITE_ASSET__BYui8ZKM__"